export default __webpack_public_path__ + "static/media/jpg.e0b84a26.svg";